// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
// 引用API文件 axios 封装
import api from "@/api/index.js"
// 引入filters
import filter from "@/service/filters"
// vuex状态管理
import store from "@/store/index"
import "@/style/style.scss"
// 引用工具文件
import utils from "@/utils/index.js"
// axios 反向代理工具
import axios from "axios"
// ElUI
import ElementUI from "element-ui"
//引入fullcalendar
import "fullcalendar"
//引入localforage
import localforage from "localforage"
import Vue from "vue"
// 国际化
import VueI18n from "vue-i18n"
// Ueditor富文样式
import vueUeditor from "vue-ueditor"
import Vuex from "vuex"
//引入样式
import "../theme/index.css"; //主题
import App from "./App"
import "./assets/c3pc/iconfont.css"
import "./assets/fullcalendar/fullcalendar.css"
import "./assets/iconfont/iconfont.css"; //icon
// import "countly-sdk-web"
import router from "./router"

console.log('这是一个埋点，测试代码是否更新',new Date())
Vue.prototype.$api = api
Vue.prototype.axios = axios

// use fiters
Object.keys(filter).forEach(key => Vue.filter(key, filter[key]))
Vue.prototype.$filter = filter

// 将工具方法绑定到全局
window.$utils = Vue.prototype.$utils = utils

window.$localforage = Vue.prototype.$localforage = localforage

Vue.use(VueI18n)
const i18n = new VueI18n({
	locale: "zh-cn", // 语言标识
	messages: {
		"zh-cn": require("./lang/zh-cn"),
		en: require("./lang/en")
	}
})
window.i18n = i18n;
Vue.config.productionTip = false

Vue.use(Vuex)
Vue.use(vueUeditor)
Vue.use(ElementUI)

// let AppVersion = "2.0.4"
// let enabledCountly = true
// if (enabledCountly) {
//   // 初始化Countly
//   Countly.init({
//     debug: false,
//     app_key: address.COUNTLY_APPKEY,
//     url: address.COUNTLY_ADDRESS,
//     app_version: AppVersion
//   })

//   // 跟踪会话
//   Countly.track_sessions()
//   Countly.track_clicks()
//   Countly.track_scrolls()
//   Countly.track_links()
//   Countly.track_forms()
//   // 跟踪错误
//   Countly.track_errors({
//     version: AppVersion
//   })
// }

/* eslint-disable no-new */
new Vue({
	el: "#app",
	i18n,
	router,
	store,
	components: { App },
	template: "<App/>"
})



// WEBPACK FOOTER //
// ./src/main.js